export default __webpack_public_path__ + "static/media/fad-logo-au.bd35a9e5.svg";